"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivablePlan = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var ReceivablePlan = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ReceivablePlan, _super);
    function ReceivablePlan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '回款计划接口';
        _this.code = '101044';
        _this.desc = '回款计划接口';
        _this.requestParams = new product_1.ReceivablePlanRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ReceivablePlan;
}(service_1.BaseService));
exports.ReceivablePlan = ReceivablePlan;
//# sourceMappingURL=receivablePlan.js.map